import enLocal from 'vant/lib/locale/lang/en-US'
import ukJame from './languageJame/uk'
import ukGaea from './languageGaea/uk'
const uk = {
  300000: '新年送礼',
  300001: '2022新年送礼',
  300002: 'SuperEx和你一起过新年',
  300003: '尊敬的SuperEx用户：<br>为庆祝SuperEx在新年之际盛大上线,<br>平台将随机空投送出价值1,000,000 USDT新年大礼包。 <br>具体活动如下：',
  300004: '活动时间<br>加拿大时间：2022年01月01日00：00-02月15日23：59',
  300005: '活动一：分享海报获空投',
  300006: '分享活动海报至＞1000人的telegram加密货币群组，并附言“百万豪礼大派送，SuperEx和你一起过新年！或分享活动海报至个人Tiwwer，置顶并附言“百万豪礼大派送，SuperEx和你一起过新年！ ”上传截图给客服，将有机会获得5 ET（价值5 USDT）。',
  300007: '活动二：邀新获VIP',
  300008: '获得期间，用户通过邀请好友新注册并成功入金≥100 USDT即为有效邀请人数。成功邀请人数越多，所获VIP等级越高。有效期（30天）',
  300009: '活动三：新用户充值送',
  300010: '活动期间，新注册用户净充值金额达到一下区间并完成一笔交易，即可获得ET奖励。 （净充值金额在活动结束前以USDT结算）活动期间，新注册用户净充值金额达到一下区间并完成一笔交易，即可获得ET奖励。 （净充值金额在活动结束前以USDT结算）',
  300011: '注意事项：',
  300012: '1.每位参与用户只能获得一次奖励 <br>2.所有参与用户默认遵守SuperEx服务条款，如发现违规将立即停止其活动资格 <br>3.SuperEx有权在不提早通知用户的情况下修改本次活动的条款 <br>4.SuperEx将取消不合规用户活动参与资格并停用相关SuperEx账户使用 <br>5.SuperEx保留本次活动最终解释权',
  300013: '立即分享',
  300014: 'SuperEx团队',
  300015: '2022年01月01日',
  300016: '更多信息关注SuperEx官网：SuperEx.com',
  300017: '净充值金额（{coin}）',
  300018: '奖励金（{coin}）',
  300019: '180天',
  300020: '净充值=总入金金额-总出金金额',
  300021: 'ET持仓数量',
  300022: 'Maker/Taker',
  300023: '有效邀请人数',
  300024: '赠送有效期',
  300025: '活动获取条件',
  300026: '注：所有赠送的VIP等级均无需ET持仓要求。 ',
  300027: 'Копіювання успішно завершено',
  300028: 'Не вдалося скопіювати',

  300029: 'Завантажте додаток SuperEx',
  300030: 'Торгуйте в будь-який час і в будь-якому місці',
  300031: 'Створити обліковий запис SuperEx',
  300032: '若您已有SuperEx账户，请先登录',
  300033: 'Електронна пошта',
  300034: 'Мобільний',
  300035: 'Номер мобільного телефону',
  300036: 'Пароль',
  300037: 'Реферальний ID (необов’язково)',
  300038: 'Я прочитав(-ла) і погоджуюсь з',
  300039: 'Умови використання SuperEx',
  300040: 'Мені більше 18 років, і я погоджуюся з умовами використання SuperEx',
  300041: 'Реєстрація',
  300042: 'Перевірка безпеки',
  300043: 'Виберіть код міста',
  300044: 'Пошук',
  300045: 'Введіть номер свого мобільного телефону',
  300046: 'Введіть правильний номер мобільного телефону',
  300047: 'Будь ласка, введіть адресу електронної пошти',
  300048: 'Введіть дійсну адресу електронної пошти',
  300049: 'Введіть пароль',
  300050: 'Мінімум 8 символів, включаючи великі літери та цифри',
  300051: 'Код підтвердження електронної пошти',
  300052: 'Код підтвердження телефону',
  300053: 'аутентифікація Google/Microsoft',
  300054: 'Google/Microsoft',
  300055: 'Заради безпеки вашого облікового запису, виконайте наступні операції перевірки',
  300056: 'Розмістити',
  300057: '6-значний код буде надіслано на {phone}',
  300058: 'Код буде надіслано на адресу {email}',
  300059: 'Введіть 6-значний код підтвердження SuperEx/Google/Microsoft',
  300060: 'Введіть 6-значний код перевірки',
  300061: 'Надіслати код',
  300062: '{timeout} с',
  300063: 'Мова',
  300064: 'На розгляді',
  300065: 'Введіть англійські літери або загальні розділові знаки',


  300066: 'Центр завдань',
  300067: 'Рейтингова битва за знижку',
  300068: 'Вимагайте до <em class="bold normal" style="font-size: 1.2rem;color: #FFC72B;">1BTC</em>',
  300069: 'Запросити',
  300070: 'Таблиця лідерів',
  300071: 'Правила розблокування',
  300072: 'Отримати більше ET',
  300073: 'Рейтингова битва за знижку. До 1 BTC чекає на вас!',
  300074: 'Завершіть транзакцію, щоб розблокувати ET',
  300075: 'Виконайте всі вищевказані завдання, щоб потрапити в білий список, і SuperEx час від часу випадковим чином роздаватиме велику кількість токенів ET користувачам із білого списку.',
  300076: 'Щоденний рейтинг',
  300077: 'Загальний рейтинг',
  300078: 'Умови обслуговування',
  300079: 'Мої нагороди',

  300080: 'Сума блокування',
  300081: 'Розблокувати суму',
  300082: 'Сума розблокування = торговий збір * розблокувати труднощі / ET ціна',
  300083: 'Перейти до торгівлі',
  300084: 'Рейтинг',
  300085: 'Обліковий запис',
  300086: 'Комісія',
  300087: 'Примітка: Щоденний рейтинг розраховується до 0:00 дня (UTC-4), а нагороди будуть випущені наступного дня. Дані можуть містити помилки лише для довідки.',
  300088: 'Примітка: Винагорода буде видана протягом 3 робочих днів після закінчення події, і дані можуть мати помилки тільки для довідки.',
  300089: 'Переглянути більше',

  300090: 'Закрити',
  300091: 'Ви вже є користувачем у білому списку!',
  300092: 'Введіть свій обліковий запис {type}',
  300093: 'Заключний крок',
  300094: 'Слідкуйте за нами на Twitter',
  300095: 'Приєднуйтесь до нашої Офіційної групи в Telegram',
  300096: 'Стартовий депозит',
  300097: 'Розпочати спотову транзакцію',
  300098: 'Негайно введіть фьючерсну угоду',
  300099: 'Представте друга, щоб зареєструватися',

  300100: 'Запросіть друга до торгівлі',
  300101: 'Порадьте другові більше торгувати',
  300102: 'Депозит',
  300103: 'Стежити',
  300104: 'Твердження',
  300105: 'Зібрано (разів)',
  300106: 'Ще не відкрито',
  300107: 'Приєднатися',
  300108: 'Записи не знайдено',
  300109: 'Завершено',
  300110: 'Запросіть друзів і отримайте більше SCS',
  300111: 'Скасувати',
  300112: 'Розмістити',
  300113: 'Не надсилати повторно',
  300114: 'Зараз немає завдань',
  300115: 'Слідкуйте за завданнями',
  300116: 'Слідкуйте за подіями!',
  300117: 'Будь ласка, введіть свій обліковий запис',
  300118: 'Будь ласка, введіть свій обліковий запис',
  300119: 'Відмовлено',
  300120: 'Миттєва реєстрація на SuperEx',
  300121: 'Зареєструватися',
  300122: 'Прострочений',
  300123: 'Папір',
  300124: 'Загадкова коробка',
  300125: 'Отримайте нагороду 1,000 USDT у таємничій скриньці зі <em class="normal bold" style="color: #FFC72B">100%</em> відсотком виграшу',
  300126: 'Правила',

  300127: 'Відкрити Mystery Box',
  300128: 'Кількість розіграшів',
  300129: 'Залишилося (моє)',
  300130: 'Відкрито (усього USDT)',
  300131: 'Нагороди',
  300132: 'Як взяти участь?',
  300133: 'Надіслати посилання із запрошенням',
  300134: 'Виконання завдань',
  300135: 'Запросіть друзів зареєструватися та виконати торгові завдання',
  300136: 'Отримати Mystery Box',

  300137: 'Виконуйте завдання та отримайте Mystery Box',
  300138: 'Ця подія вже завершилася, з нетерпінням чекайте наступної події!',
  300139: 'Ця подія ще не почалася, слідкуйте за оновленнями!',
  300140: 'Правила події',
  300141: 'ОК',
  300142: 'Час',
  300143: '',
  300144: '',
  300145: 'Запросити друзів',
  300146: ' Запалюйте ліхтарики та веселіться на <em class="normal" style="color: #FFC72B">Хелловін</em>',
  300147: 'Заходьте у SuperEx <em class="normal" style="color: #FFC72B">{num}</em> днів поспіль та отримайте шанс виграти приз у <em class="normal" style="color: #FFC72B">{amount} ET</em>',
  300148: 'Список переможців',
  300149: 'Щоденний вхід',

  300150: 'Ви заходили {num} дні тому',
  300151: 'Розіграш призів',
  300152: 'Ви ввійшли',
  300153: 'Увійти',
  300154: '',
  300155: '',
  300156: 'Увійти',
  300157: 'Отримайте кредитний ваучер на контрактну комісію!',
  300158: 'Успішне підвищення VIP-рівня!',
  300159: 'Отримайте шанс виграти у лотереї!',

  300160: 'Купон на комісію за контрактом',
  300161: 'VIP-підвищення',
  300162: '',
  300163: 'Ви маєте можливість перезайти <em class="normal" style="color: #FFC72B">{num}</em> рази ',
  300164: 'Отримайте можливість увійти',
  300165: 'Можна перезайти',
  300166: 'Поради',
  300167: 'Успішний повторний вхід',
  300168: 'Якщо у вас ще немає достатньої кількості входів, ви можете отримати 1 додатковий вхід за депозит ≥{num} {symbol} в той же день.',
  300169: 'Увійти',

  300170: 'Ви досягли ліміту повторного входу',
  300171: 'Список переможців серед користувачів, які входили в систему 7 днів поспіль',
  300172: 'Входьте безперервно, щоб отримати наступні винагороди',
  300173: 'Готово',
  300174: '{num}дні',
  300175: 'Купон',
  300176: 'Мій VIP-рівень',
  300177: 'Беріть участь у лотереї',
  300178: 'Вітаємо!',
  300179: 'Успішний вхід',
  300180: '',
  300181: 'Академія',
  300182: 'Новини',
  300183: 'Дані',
  300184: 'Вчити',
  300185: 'Детально ознайомтеся з основними подіями світової криптоіндустрії',
  300186: 'Отримайте короткий огляд останніх подій у криптоіндустрії у всьому світі',
  300187: 'Дізнайтеся все про блокчейн, Web3 і криптовалюту',
  300188: 'Читайте більше',
  300189: 'Відео',
  300190: 'Завантаження',
  300191: 'Все завантажено',
  300192: 'Всі',
  300193: 'Турнір не розпочався',
  300194: 'Виберіть переможця чемпіонату світу з футболу, щоб виграти лімітований <em class="normal" style="color: #DBFF00">Бонус</em>',
  300195: 'Час події',
  300196: 'Результати голосування',
  300197: 'Груповий етап',
  300198: 'Група {num}',
  300199: 'Призовий фонд: {num}',
  300200: 'Проголосувати',
  300201: 'Нокаут-етап',
  300202: 'Змагання',
  300203: 'Кінцевий термін для голосування',
  300204: 'Проголосувати',
  300205: 'Будь ласка, введіть кількість голосів',
  300206: 'Мінімальна кількість ставок: {num} ET.',
  300207: 'Час прогнозу',
  300208: 'Ставки на команди',
  300209: 'Голосування',
  300210: 'Сума призу',
  300211: 'Кваліфіковані команди',
  300212: 'Д',
  300213: 'Г',
  300214: 'ХВ',
  300215: 'С',
  300216: 'Тайми',
  300217: 'Подія ще не розпочалась',
  300218: '1/4 Фіналу',
  300219: 'Підтвердити',
  300220: 'Кількість голосів',
  300221: 'Недостатній баланс',
  300222: 'Депозит',
  300223: 'Вдалий прогноз',
  300224: '1/8 Фіналу',
  300225: 'Півфінал',
  300226: 'Фіналісти за третє та четверте місце',
  300227: 'Фінал',
  300228: 'Перемога',
  300229: 'Поразка',
  300230: 'Загальний призовий фонд:{num} ET',
  300231: 'Переглянути інші матчі',
  300232: 'Інші змагання',
  300233: 'Валюта',
  300234: 'Ринкова ціна',
  300235: 'Зміна за 24Г',
  300236: 'Керівництво для нового користувача',
  300237: 'Почніть вчитися торгівлі криптовалютами вже зараз',
  300238: 'Світова присутність',
  300239: 'Без кордонів, децентралізація комьюніті та автономія, децентралізація команди - це головна ціль розробки SuperEx',

  300240: 'Нульові ризики для безпеки',
  300241: 'Інтегрований SuperWallet, приватний ключ якого зашифрований і зберігається на пристрої користувача. Не залежить від безпеки коду або інших факторів',
  300242: 'Без реєстрації та KYC',
  300243: 'Транзакції з авторизацією через гаманець, без реєстрації, без KYC, перевірка транзакцій завершується у ланцюжку, який неможливо підробити, є безпечним та прозорим',
  300244: 'Відкрита система ',
  300245: 'Ми дозволяємо користувачам взаємодіяти з D-App або смарт-контрактами, відкривши SuperWallet, користувачі можуть брати участь в Meta, DeFi та NFT',
  300246: 'Космічний фонд',
  300247: 'Космічний фонд використовується для дослідження космосу або для фінансування установ чи осіб, які зробили значний внесок в його освоєння людиною',
  300248: 'Безпечна та проста у використанні біржа',
  300249: 'Завантажуйте мобільний додаток SuperEx, щоб бути в курсі подій на ринках і торгувати в ідеальний момент, де б ви не знаходилися.',

  300250: 'Додаткові параметри завантаження',
  300251: 'Кожен ваш трейд - це паливо для польоту у космос!',
  300252: 'Зареєструватися зараз',
  300253: 'iOS і Android<br>Скануйте для завантаження',
  300254: 'Аутентифікатор',
  300255: 'Аутентифікатор згенерує для вас код двоетапної перевірки. Двоетапна перевірка зробить ваш акаунт SuperEx ще більш захищеним.',
  300256: 'Аутентифікатор SuperEx',
  300257: 'Google аутентифікатор ',
  300258: 'Microsoft аутентифікатор',
  300259: 'Завантажте клієнт (iPhone)',

  300260: 'Завантажте клієнт (Android)',
  300261: 'Найбезпечніша у світі платформа для торгівлі цифровими активами！',
  300262: 'Про нас',
  300263: 'Умови',
  300264: 'Конфіденційність',
  300265: 'Оголошення',
  300266: 'Академія',
  300267: 'Центр початківців',
  300268: 'Спотова торгівля',
  300269: 'Фьючерси',

  300270: 'FAQ',
  300271: 'Послуги',
  300272: 'Комісії',
  300273: 'Правила',
  300274: 'Заява на лістинг',
  300275: 'Реферал',
  300276: 'Зв\'язатися з нами',
  300277: 'Центр підтримки',
  300278: 'Надіслати запит',
  300279: 'Бізнес-контакти',

  300280: 'Інституційна співпраця',
  300281: 'Більше',
  300282: 'З поверненням!',
  300283: 'Забули пароль?',
  300284: 'У вас ще немає облікового запису?',
  300285: "Перейдіть у додаток або до комп'ютера, щоб відновити пароль",
  300286: 'OK',

  300287: 'Підтвердити',
  300288: 'Буде оголошено',
  300289: 'Буде заявлено',

  300290: 'Вже приєднались',
  300291: 'Кошти вже повернуто',
  300292: 'Правила купівлі',
  300293: "Купити  <span style='color: #ffc72b;'>Товари</span>",
  300294: 'Вибирайте та купуйте',
  300295: 'Очікування результатів',
  300296: 'Отримати предмет',
  300297: 'Депозит',
  300298: 'Запис купівлі',
  300299: 'Список предметів',
  300300: 'Одноразова плата за участь',
  300301: 'Продано {num} квитки. Товар буде продано після досягнення суми у {price} {currency}.',
  300302: 'Приєднатися зараз',
  300303: 'Приєднатися знову',
  300304: 'Виберіть кількість квитків для покупки',
  300305: "Для 1 квитка потрібно <span style='color: #fa4d56;'>{minPrice} {currency}</span>, а один предмет можна придбати за максимум <span style='color: #fa4d56;'>{maxBuyCount} квитків</span>",
  300306: 'квитків',
  300307: 'У вас є {num} {currency}, чим більше копій ви придбаєте, тим більше шансів на виграш!',
  300308: 'Придбати',
  300309: 'Наступного разу',
  // 300309: '余额充值',
  300310: 'Вітаємо!',
  300311: 'Отримати',
  300312: 'Спробуйте знову!',
  300313: 'Зробіть криптовалютний або P2P-депозит у додатку.',
  // 300314: '我知道了',
  300315: 'Щоб отримати товар, зв’яжіться зі службою підтримки клієнтів у додатку.',
  // 300316: '我知道了',
  300317: 'Вхід / Реєстрація',
  300318: 'Вартість {num} {currency}',
  300319: 'Опис товару',
  300320: 'Моя участь',
  300321: 'Час',
  300322: 'Доступні предмети',
  300323: 'Кількість придбаних квитків',
  300324: 'Сума повернення',
  300325: 'Операція',
  300326: 'Отримати',
  300327: 'Вже маєте обліковий запис?',
  300328: 'Увійти',
  300329: 'Код автентифікації',
  300330: 'Показуються лише записи за останні сім днів',
  300331:'Аутентифікатор',
  300332:'Завантажити',
  300333:'1 Bitcoin  можна купити за 1 USDT',
  300334:"Ціна покупки",
  300335:"Попередні результати ",
  // 300336:"期次",
  300337:"Правила перегляду ",
  300338:"Випуск: [Фаза {num}]. ",
  300339:"Покупка у процесі",
  300340:"Успішно зареєстровані користувачі",
  300341:"Час оголошення ",
  300342:"Поділитися ",
  300343:"Випуск [{num}]",
  300345:"Завантажити",
  300346:"Поділіться своєю покупкою ",
  300347:"Відскануйте код, щоб приєднатися ",
  300348:"Отримати предмет",
  300349:"Примітка: активи будуть надіслані на ваш рахунок протягом 48 годин.",
  300350:"Зв’яжіться зі службою підтримки клієнтів, щоб отримати інші товари",
  300351:"Переглянути",
  300352:"Зареєструватися зараз ",
  300353:"Зареєстровано ",
  300354:'Реєстрація закрита',
  300355:'Успішна реєстрація ',
  300356:'відкрити програму',
  300357:'Вітаємо {user} із придбанням {shop}!',
  300358:'Центр подій',
  300359:'У процесі',
  300360:'Скоро розпочнеться',
  300361:'Закінчено',
  300362:'Приєднуйтесь зараз',
  300363: 'Закінчено',
  300364: 'Переможці',
  300365: 'Переможці будуть оголошені найближчим часом',
  300366: 'Валюта',
  300367: 'Продати',
  200368: 'Сплата',
  300369: 'Отримати',
  300370: 'Отримати',
  300371: 'Ліміт на одну транзакцію:',
  300372: 'Метод оплати',
  300373: 'Метод оплати',
  300374: 'Платіжний провайдер',
  300375: 'Деталі замовлення',
  300376: 'Сума (включаючи комісію за транзакцію)',
  300377: 'Час прибуття',
  300378: 'Відмова від відповідальності',
  300379: 'Я прочитав(-ла) та погоджуюсь із застереженням',
  300380: "You will leave SuperEx and jump to <span>{name}</span>, a licensed financial institution that provides card payment processing capabilities as a third party. Any risk events that occur during use will be borne by <span>{name}</span>. Please read and agree to <a class= 'pointer' href={server}>Service Agreement</a> before using its services.If you have any questions about credit card deposits, please contact <a class='pointer' href={Customer}>{name} Customer Service</a> for more details.",
  300381: 'Як купити криптовалюту на SuperEx?',
  300382: 'Як продати криптовалюту на SuperEx?',
  300383: 'Розмістіть замовлення на покупку криптовалюти',
  300384: 'Виберіть фіатну валюту, якою ви хочете заплатити, і криптовалюту, яку хочете купити. Введіть суму, яку ви хочете витратити.',
  300385: 'Підтвердіть свою особу',
  300386: 'Пройдіть перевірку KYC на SuperEx і у постачальника послуг, щоб завершити платіж',
  300387: 'Перевірте деталі вашого замовлення',
  300388: 'Перевірте історію депозитів, щоб переглянути статус вашого замовлення.',
  300389: 'FAQ',
  300390: '1. Які способи оплати я можу використовувати для купівлі криптовалюти?',
  300391: 'Наразі SuperEx підтримує VISA, Mastercard, Apple Pay, Google Pay та інші способи оплати. Підтримувані сторонні постачальники послуг включають Mercuryo і alchemypay.',
  300392: '2. Які криптовалюти я можу придбати?',
  300393: 'SuperEx підтримує основні криптовалюти, такі як BTC, ETH, USDT, LTC, USDC, XRP, BCH, CRV і TRX.',
  300394: '3. Чи контролює SuperEx якість і ціни підтримуваних сторонніх постачальників послуг?',
  300395: 'SuperEx ретельно відібрав ряд постачальників послуг з надійною галузевою репутацією, популярністю і безпекою, щоб надати користувачам спрощені послуги.',
  300396: '4. Які комісії потрібно сплатити, щоб купити криптовалюту?',
  300397: 'Ви сплачуєте комісію сторонньому постачальнику послуг і комісію за переказ в ланцюжку. SuperEx не стягує жодних комісій.',
  300398: '5. Скільки часу потрібно для отримання криптовалюти після оплати?',
  300399: 'Після завершення платежу на платформі стороннього постачальника послуг ваша криптовалюта буде зарахована на ваш спот-рахунок на SuperEx приблизно через 2-10 хвилин.',
  300400: '6. Що робити, якщо у мене виникнуть проблеми в процесі покупки?',
  300401: 'Зверніться до служби підтримки клієнтів, якщо у вас виникнуть будь-які проблеми в процесі транзакції. Якщо ви не отримали криптовалюту після завершення оплати, зверніться до стороннього постачальника послуг для перевірки деталей замовлення (зазвичай це найефективніший метод). Через IP-адресу вашого поточного регіону або певні політичні причини, вам доведеться вибрати перевірку людиною.',
  300402: "Доступно",
  300403: 'Недостатній баланс',
  300404: 'Please enter currency',
  300405: 'Введіть фіатну валюту',
  300406: 'Ви не пройшли верифікацію особи',
  300407: "Для безпеки вашого облікового запису з іншими користувачами, будь ласка, спочатку пройдіть верифікацію особи",
  300408: 'Не перевірено',
  300409: 'Не верифіковано',
  300410: 'Виберіть валюту',
  300411: 'Оберіть фіатну валюту',
  300412: 'All currencies',
  300413: 'Всі фіатні валюти',
  300414: '≈{time} хвилин',
  300415: 'На даний момент торгівля P2P не відкрита для авторизованих гаманцем користувачів, будь ласка, використовуйте свій обліковий запис SuperEx для входу і торгівлі P2P',
  300416: 'https://support.superex.com/hc/en-001/articles/23084120565017',
  300417:'Купити',
  300418: 'Серійний номер',
  300419: 'Хеллоуїнський карнавал SuperEx',
  300420: 'Увійдіть, щоб отримувати подарунки та торгуйте, щоб виграти бонуси!',
  300421:'Тип',
  300422:'Винагороди в криптовалюті',
  300423:'',
  300424:'',

  310000:'Огляд винагороди',
  310001:'SCS Airdrop',

  400000:'Перша криптобіржа Web3',
  400001:'Приєднуйтеся до нас, щоб створити фінансовий світ',
  400002:'Кожен ваш трейд - це паливо для польоту у космос!',
  400003:'Перегляд моменту SuperEX',
  400004:'Кожен чудовий момент є свідком наших кроків і силою рухатися вперед',
  400005:'Вибрати мову та регіон',
  400006:'0 РИЗИКІВ',
  400007:'БЕЗ KYC',
  400008:'ВІДКРИТО',
  400009:'фонд',
  400010:'Переглянути в основній мережі',
  400011:'Переглянути в тестовій мережі',
  400012:'Документи для розробників',
  400013:'Інше',
  400014:'Зона ET',
  400015:'',

  ...enLocal,
  ...ukJame,
  ...ukGaea
}
export default uk;



// WEBPACK FOOTER //
// ./src/i18n/langs/uk.js